import React, {useState} from "react";
import {
    DragDropContext,
    Draggable,
    Droppable
} from "react-beautiful-dnd";
import {useTable} from "react-table";
import {useFieldArray, useWatch} from "react-hook-form";

import {
    Button,
    IconButton,
    Paper,
    Switch,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    TextField,
    withStyles,
} from "@material-ui/core";
import CancelRoundedIcon
    from "@material-ui/icons/CancelRounded";
import DragHandleIcon from "@material-ui/icons/DragHandle";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import Delete from "@material-ui/icons/Delete";
import apiHelper from "../../../../util/ApiHelper";
import {modal} from "../../../../util";

const BlueSwitch = withStyles({
    switchBase: {
        "&$checked": {
            color: "#306F9D",
        },
        "&$checked + $track": {
            backgroundColor: "#306F9D",
        },
    },
    checked: {},
    track: {},
})(Switch);

const IsDraggingContext = React.createContext(false);

const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
};

class DraggableTableCell extends React.Component {
    getSnapshotBeforeUpdate(prevProps) {
        if (!this.ref) {
            return null;
        }

        const isDragStarting =
            this.props.isDragOccurring && !prevProps.isDragOccurring;

        if (!isDragStarting) {
            return null;
        }

        const {
            width,
            height
        } = this.ref.getBoundingClientRect();

        const snapshot = {
            width,
            height,
        };

        return snapshot;
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const ref = this.ref;
        if (!ref) {
            return;
        }

        if (snapshot) {
            if (ref.style.width === snapshot.width) {
                return;
            }
            ref.style.width = `${snapshot.width}px`;
            ref.style.height = `${snapshot.height}px`;
            return;
        }

        if (this.props.isDragOccurring) {
            return;
        }

        // inline styles not applied
        if (ref.style.width == null) {
            return;
        }

        // no snapshot and drag is finished - clear the inline styles
        ref.style.removeProperty("height");
        ref.style.removeProperty("width");
    }

    setRef = (ref) => {
        this.ref = ref;
    };

    render() {
        return (
            <TableCell
                style={{paddingTop: 12, paddingBottom: 12}}
                ref={this.setRef}
                align={this.props.align}
            >
                {this.props.children}
            </TableCell>
        );
    }
}

const DraggableTableRow = ({
                               snapshot,
                               provided,
                               className,
                               row,
                               index,
                               handleDeleteBanner,
                               disabled,
                               getValues,
                               uploading,
                               toggleHover,
                               hoverToggle,
                               handleFileUpload,
                               setUploading,
                               handleDeleteFile,
                           }) => {
    return (
        <IsDraggingContext.Consumer>
            {(isDragging) => (
                <TableRow
                    className={className}
                    ref={provided.innerRef}
                    isDragging={snapshot.isDragging}
                    {...provided.draggableProps}
                >
                    {row.cells.map((cell) => {
                        if (
                            cell.column.id !== "dragHandle" &&
                            cell.column.id !== "action"
                        ) {
                            if (cell.column.id === "image") {
                                return (
                                    <DraggableTableCell
                                        isDragOccurring={isDragging}
                                        scope="row">
                                        {/* this condition checks if current banner contains an image  */}
                                        {getValues(`rotationBanners.${row.index}.image`) ? (
                                            // when the image is being uploaded
                                            uploading[row.index] ? (
                                                <div>loading...</div>
                                            ) : (
                                                // otherwise, when image is detected
                                                <div
                                                    style={{
                                                        position: "relative",
                                                        width: "100%",
                                                        height: "40px",
                                                    }}
                                                    onMouseEnter={() => toggleHover(row.index, true)}
                                                    onMouseLeave={() => toggleHover(row.index, false)}
                                                >
                                                    <img
                                                        style={{
                                                            width: "100%",
                                                            height: "100%",
                                                            cursor: "pointer"
                                                        }}
                                                        src={getValues(
                                                            `rotationBanners.${row.index}.image`
                                                        )}
                                                        alt=""
                                                        onClick={() => window.open(getValues(
                                                            `rotationBanners.${row.index}.image`
                                                        ), '_blank').focus()}
                                                    />
                                                    {/* show delete icon when hover on image */}
                                                    {hoverToggle[row.index] && !disabled ? (
                                                        <div
                                                            style={{
                                                                position: "absolute",
                                                                background: "#FFF",
                                                                top: 0,
                                                                right: 0,
                                                                borderRadius: "100%",
                                                                width: "12px",
                                                                height: "12px",
                                                            }}
                                                        >
                                                            <CancelRoundedIcon
                                                                style={{
                                                                    position: "absolute",
                                                                    top: 0,
                                                                    right: 0,
                                                                    width: "100%",
                                                                    height: "100%",
                                                                    transform: "scale(1.5)",
                                                                    cursor: "pointer",
                                                                }}
                                                                onClick={() => handleDeleteFile(row.index)}
                                                            />
                                                        </div>
                                                    ) : (
                                                        <></>
                                                    )}
                                                </div>
                                            )
                                        ) : (
                                            // else, when no image is present in the banner
                                            <div>
                        <span
                            style={{paddingRight: "10px"}}>
                          No image selected
                        </span>
                                                <input
                                                    style={{display: "none"}}
                                                    id={`upload-rotation-image-${row.index}`}
                                                    type="file"
                                                    onChange={(e) => {
                                                        setUploading({
                                                            ...uploading,
                                                            [row.index]: true,
                                                        });
                                                        handleFileUpload(row.index, e);
                                                    }}
                                                />
                                                <Button
                                                    component="label"
                                                    htmlFor={`upload-rotation-image-${row.index}`}
                                                    variant="contained"
                                                    disableElevation
                                                    style={{
                                                        color: "#306F9D",
                                                        background: "#F1F1F1",
                                                        margin: "0px",
                                                        padding: "7px 15px",
                                                        border: "1px solid #306F9D",
                                                    }}
                                                >
                                                    Add
                                                    Image
                                                </Button>
                                            </div>
                                        )}
                                    </DraggableTableCell>
                                );
                            } else {
                                return (
                                    <DraggableTableCell
                                        isDragOccurring={isDragging}
                                        scope="row">
                                        {cell.render("Cell")}
                                    </DraggableTableCell>
                                );
                            }
                        } else {
                            return null;
                        }
                    })}

                    <TableCell>
                        {disabled || (
                            <IconButton
                                size="small"
                                onClick={() => {
                                    handleDeleteBanner(index);
                                }}
                            >
                                <Delete fontSize="inherit"/>
                            </IconButton>
                        )}
                    </TableCell>

                    <TableCell
                        style={{
                            paddingBottom: 12,
                            color: "#CCCCCC"
                        }}
                        {...provided.dragHandleProps}
                    >
                        <DragHandleIcon/>
                    </TableCell>
                </TableRow>
            )}
        </IsDraggingContext.Consumer>
    );
};

export default function RotationBannerSection(props) {
    const {
        register,
        defaultValues,
        Controller,
        control,
        setValue,
        getValues,
        disabled,
    } = props;

    const {fields, append, remove, move} = useFieldArray({
        control,
        name: "rotationBanners",
    });

    const watchRotationBanners = useWatch({
        control,
        name: "rotationBanners",
    });

    const controlledFields = React.useMemo(
        () =>
            fields.map((field, index) => {
                return {
                    ...field,
                    ...watchRotationBanners[index],
                };
            }),
        [fields, watchRotationBanners]
    );

    const [isDragging, setIsDragging] = useState(false);
    const [uploading, setUploading] = useState({});
    const [hoverToggle, setHoverToggle] = useState({});
    const [moving, setMoving] = useState(false);
    const didChangeRef = React.useRef(false);

    React.useLayoutEffect(() => {
        if (moving) setMoving(false);
    }, [moving]);

    const toggleHover = React.useCallback(
        (index, bool) => {
            setHoverToggle({...hoverToggle, [index]: bool});
        },
        [hoverToggle]
    );

    const uploadFile = async (file) => {
        try {
            const result = await apiHelper.hknt.hkntUploadFile(file);
            return result.data.url;
        } catch (err) {
            console.log(err);
        }
    };

    const handleFileUpload = React.useCallback(
        async (index, e) => {
            setValue(`rotationBanenrs.${index}.image`, "loading");
            const file = e.target.files[0];
            if (file) {
                const url = await uploadFile(file);
                setValue(`rotationBanners.${index}.image`, url);
            }
            setUploading({...uploading, [index]: false});
        },
        [setValue, uploading]
    );

    const handleDeleteFile = React.useCallback(
        async (index) => {
            const decision = await modal.fire({
                title: "Delete Image",
                text: "Are you sure to delete this image?",
                showCancelButton: true,
                confirmButtonText: `Delete`,
            });
            if (decision.isConfirmed) {
                setValue(`rotationBanners.${index}.image`, "");
            }
        },
        [setValue]
    );

    const handleDeleteBanner = async (index) => {
        const decision = await modal.fire({
            title: "Delete Banner",
            text: "Are you sure to delete this banner?",
            showCancelButton: true,
            confirmButtonText: `Delete`,
        });
        if (decision.isConfirmed) {
            let clonedFields = controlledFields.slice();
            remove(index);
            clonedFields.splice(index, 1);
            setValue("rotationBanners", clonedFields);
            setTimeout(() => {
                didChangeRef.current = true;
            }, 0);
        }
    };

    const handleAddBanner = () => {
        const newBanner = {
            id: 0,
            image: "",
            localizations: {
                en: {
                    url: "",
                },
                tc: {
                    url: "",
                },
            },
            seq: fields.length,
            status: false,
        };
        const clonedFields = [...controlledFields];
        append(newBanner);
        setValue("rotationBanners", [...clonedFields, newBanner]);
        setMoving(true);
    };

    const columns = React.useMemo(
        () => [
            {
                Header: "Banner Image",
                accessor: "image",
            },
            {
                Header: "Banner Link/URL (Traditional Chinese)",
                accessor: "localizations.tc.url",
                Cell: ({row}) => (
                    <Controller
                        name={`rotationBanners.${row.index}.localizations.tc.url`}
                        control={control}
                        defaultValue={
                            didChangeRef.current
                                ? getValues(`rotationBanners.${row.index}.localizations.tc.url`)
                                : defaultValues[row.index] &&
                                defaultValues[row.index].localizations.tc.url
                        }
                        render={({
                                     field,
                                     fieldState: {error}
                                 }) => (
                            <TextField
                                variant="outlined"
                                margin="dense"
                                fullWidth
                                {...field}
                            />
                        )}
                    />
                ),
            },
            {
                Header: "Banner Link/URL (English)",
                accessor: "localizations.en.url",
                Cell: ({row}) => (
                    <Controller
                        name={`rotationBanners.${row.index}.localizations.en.url`}
                        control={control}
                        defaultValue={
                            didChangeRef.current
                                ? getValues(`rotationBanners.${row.index}.localizations.en.url`)
                                : defaultValues[row.index] &&
                                defaultValues[row.index].localizations.en.url
                        }
                        render={({
                                     field,
                                     fieldState: {error}
                                 }) => (
                            <TextField
                                variant="outlined"
                                margin="dense"
                                fullWidth
                                {...field}
                            />
                        )}
                    />
                ),
            },
            {
                Header: "Status",
                accessor: "status",
                Cell: ({row}) => (
                    <Controller
                        name={`rotationBanners.${row.index}.status`}
                        control={control}
                        defaultValue={
                            didChangeRef.current
                                ? !!getValues(`rotationBanners.${row.index}.status`)
                                : defaultValues[row.index] && !!defaultValues[row.index].status
                        }
                        render={({
                                     field: {
                                         value,
                                         onChange,
                                         ref
                                     },
                                     fieldState: {error},
                                 }) => (
                            <BlueSwitch
                                checked={value}
                                onChange={onChange}
                                disabled={disabled}
                                inputRef={ref}
                            />
                        )}
                    />
                ),
            },
        ],
        [control, defaultValues, disabled, getValues]
    );

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow
    } =
        useTable(
            {
                columns,
                data: controlledFields,
            },
            (hook) => {
                hook.visibleColumns.push((columns) => [
                    {
                        id: "no",
                        Header: () => <div>No</div>,
                        Cell: ({row}) =>
                            <p>{row.index + 1}</p>,
                    },
                    ...columns,
                    {
                        id: "action",
                        Header: () => <div>Action</div>,
                    },
                    {
                        id: "dragHandle",
                        Header: () => <></>,
                    },
                ]);
            }
        );

    const onBeforeDragStart = () => {
        setIsDragging(true);
    };

    const onDragEnd = (result) => {
        // dropped outside the list
        if (!result.destination) {
            return;
        }
        didChangeRef.current = true;
        const items = reorder(
            controlledFields,
            result.source.index,
            result.destination.index
        );
        move(result.source.index, result.destination.index);
        setValue("rotationBanners", items);
        setMoving(true);
    };

    return (
        <>
            <IsDraggingContext.Provider value={isDragging}>
                <Paper variant="outlined">
                    <Table aria-label="simple table"
                           component="div" {...getTableProps()}>
                        <TableHead style={{width: "100%"}}>
                            {headerGroups.map((headerGroup) => (
                                <TableRow {...headerGroup.getHeaderGroupProps()}>
                                    {headerGroup.headers.map((column) =>
                                        column.id === "no" ? (
                                            <TableCell
                                                style={{width: 100}}>No</TableCell>
                                        ) : column.id === "status" ||
                                        column.id === "action" ||
                                        column.id === "dragHandle" ? (
                                            <TableCell
                                                style={{
                                                    width: 50,
                                                    textAlign: "center"
                                                }}>
                                                {column.render("Header")}
                                            </TableCell>
                                        ) : column.id === "bannerImage" ? (
                                            <TableCell
                                                style={{width: 400}}>
                                                {column.render("Header")}
                                            </TableCell>
                                        ) : (
                                            <TableCell
                                                style={{width: 500}}>
                                                {column.render("Header")}
                                            </TableCell>
                                        )
                                    )}
                                </TableRow>
                            ))}
                        </TableHead>
                        <DragDropContext
                            onBeforeDragStart={onBeforeDragStart}
                            onDragEnd={onDragEnd}
                        >
                            <Droppable
                                droppableId="droppable"
                                type="QUESTIONS">
                                {(provided, snapshot) => (
                                    <TableBody
                                        component="div"
                                        ref={provided.innerRef}
                                        {...provided.droppableProps}
                                        {...getTableBodyProps()}
                                    >
                                        {!moving &&
                                            rows.map((row, i) => {
                                                prepareRow(row);
                                                return (
                                                    <Draggable
                                                        key={row.id}
                                                        draggableId={row.id}
                                                        index={i}
                                                        isDragDisabled={disabled}
                                                    >
                                                        {(provided, snapshot) => (
                                                            <DraggableTableRow
                                                                register={register}
                                                                key={row.id}
                                                                row={row}
                                                                provided={provided}
                                                                snapshot={snapshot}
                                                                index={i}
                                                                handleDeleteBanner={handleDeleteBanner}
                                                                disabled={disabled}
                                                                getValues={getValues}
                                                                handleDeleteFile={handleDeleteFile}
                                                                handleFileUpload={handleFileUpload}
                                                                hoverToggle={hoverToggle}
                                                                toggleHover={toggleHover}
                                                                uploading={uploading}
                                                                setUploading={setUploading}
                                                            />
                                                        )}
                                                    </Draggable>
                                                );
                                            })}
                                        {provided.placeholder}
                                    </TableBody>
                                )}
                            </Droppable>
                        </DragDropContext>
                    </Table>
                </Paper>
            </IsDraggingContext.Provider>
            {disabled || (
                <Button
                    onClick={handleAddBanner}
                    style={{
                        color: "#306F9D",
                        margin: "5px 0",
                    }}
                >
                    <AddCircleIcon/>
                    Add New Banner
                </Button>
            )}
        </>
    );
}
